<template>
  <div class="split">
    <!-- ===== HOMEKIND ===== -->
    <section class="split__side split__side--hk">
      <div class="split__blob split__blob--hk-1"></div>
      <div class="split__blob split__blob--hk-2"></div>
      <IlloPlant class="split__plant" />

      <div class="split__content">
        <HomekindLogo :size="46" class="split__brand" />
        <span class="split__badge split__badge--hk">
          <span class="split__dot"></span>
          Aplikasi Rumah Tangga · Closed Beta
        </span>
        <h2 class="split__title">
          Satu aplikasi untuk <span class="split__hl--hk">semua urusan rumah</span>
        </h2>
        <p class="split__text">
          Keuangan, tagihan, agenda, daftar belanja, dan perawatan rumah dalam satu tempat yang dipakai bersama seisi
          rumah.
        </p>
        <div class="split__chips">
          <span v-for="chip in homekindChips" :key="chip.label" class="split__chip split__chip--hk">
            <i :class="chip.icon"></i> {{ chip.label }}
          </span>
        </div>
        <router-link to="/homekind" class="split__btn split__btn--hk">
          Buka Homekind <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>

      <div class="split__visual">
        <div class="split__arch"></div>
        <PhoneMockup screen="home" compact class="split__phone" />
      </div>
    </section>

    <!-- ===== MIRAVERSE SOLUSI IT ===== -->
    <section class="split__side split__side--mira">
      <div class="split__blob split__blob--mira-1"></div>
      <div class="split__blob split__blob--mira-2"></div>

      <div class="split__content">
        <div class="split__brand split__brand--mira">
          <img :src="miraLogo" alt="Miraverse.ID" />
          <span>Miraverse<span class="split__mira-accent">.ID</span></span>
        </div>
        <span class="split__badge split__badge--mira">
          <span class="split__dot split__dot--mira"></span>
          Solusi IT untuk Bisnis
        </span>
        <h2 class="split__title split__title--mira">
          Pusat solusi IT untuk <span class="split__hl--mira">bisnis Anda</span>
        </h2>
        <p class="split__text">
          Dari website perusahaan, aplikasi web &amp; mobile, hingga ERP, CRM, dan cloud. Kami bantu bisnis Anda
          bertransformasi ke era digital.
        </p>
        <div class="split__chips">
          <span v-for="chip in miraChips" :key="chip.label" class="split__chip split__chip--mira">
            <i :class="chip.icon"></i> {{ chip.label }}
          </span>
        </div>
        <router-link to="/solusi-it" class="split__btn split__btn--mira">
          Lihat Solusi IT <i class="fa fa-arrow-right"></i>
        </router-link>
      </div>

      <div class="split__visual">
        <div class="split__photo">
          <img :src="miraImage" alt="Tim Miraverse" />
          <div class="split__photo-stats">
            <div v-for="stat in miraStats" :key="stat.label">
              <strong>{{ stat.value }}</strong>
              <span>{{ stat.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomekindLogo from "@/components/homekind/HomekindLogo";
import PhoneMockup from "@/components/homekind/PhoneMockup";
import IlloPlant from "@/components/homekind/illustrations/IlloPlant";

export default {
  name: "HomePage",
  components: { HomekindLogo, PhoneMockup, IlloPlant },
  data() {
    return {
      miraLogo: require("@/assets/images/logo-mira.png"),
      miraImage: require("@/assets/images/hero-image.png"),
      homekindChips: [
        { icon: "fa fa-pie-chart", label: "Kas & Anggaran" },
        { icon: "fa fa-calendar", label: "Agenda" },
        { icon: "fa fa-shopping-basket", label: "Daftar Belanja" },
        { icon: "fa fa-wrench", label: "Perawatan Rumah" },
      ],
      miraChips: [
        { icon: "fa fa-globe", label: "Company Website" },
        { icon: "fa fa-mobile", label: "Web & Mobile" },
        { icon: "fa fa-cogs", label: "ERP & CRM" },
        { icon: "fa fa-cloud", label: "Cloud & Domain" },
      ],
      miraStats: [
        { value: "10+", label: "Proyek" },
        { value: "5+", label: "Tahun" },
        { value: "24/7", label: "Dukungan" },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.split {
  display: flex;
  min-height: 100vh;
}

.split__side {
  position: relative;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 48px 0;
  overflow: hidden;
  transition: flex-grow 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  &--hk {
    background: radial-gradient(ellipse at 30% 30%, #3d5f4a 0%, $hk-forest 55%, $hk-forest-deep 100%);
  }

  &--mira {
    background: radial-gradient(ellipse at 70% 30%, $dark-bg-lighter 0%, $dark-bg 60%, #12061f 100%);
  }
}

// Hovered side widens a little on desktop to invite the click
@media (hover: hover) and (min-width: 992px) {
  .split__side:hover {
    flex-grow: 1.2;
  }
}

.split__blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;

  &--hk-1 {
    top: -10%;
    left: -15%;
    width: 460px;
    height: 460px;
    background: rgba(242, 185, 143, 0.12);
    filter: blur(90px);
  }

  &--hk-2 {
    bottom: -10%;
    right: -10%;
    width: 380px;
    height: 380px;
    background: rgba(169, 196, 165, 0.14);
    filter: blur(80px);
  }

  &--mira-1 {
    top: -15%;
    right: -15%;
    width: 480px;
    height: 480px;
    background: rgba(108, 41, 115, 0.35);
    filter: blur(100px);
  }

  &--mira-2 {
    bottom: -15%;
    left: -10%;
    width: 380px;
    height: 380px;
    background: rgba(199, 52, 104, 0.18);
    filter: blur(90px);
  }
}

.split__content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 520px;
}

.split__brand {
  display: inline-flex;
  margin-bottom: 22px;

  &--mira {
    align-items: center;
    gap: 12px;
    font-family: $font-heading;
    font-size: 1.45rem;
    font-weight: 800;
    color: #fff;

    img {
      height: 46px;
    }
  }
}

.split__mira-accent {
  color: $brand-magenta;
}

.split__badge {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 6px 14px;
  margin-bottom: 16px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  &--hk {
    background: rgba(246, 241, 231, 0.1);
    border: 1px solid rgba(246, 241, 231, 0.18);
    color: $hk-linen;
  }

  &--mira {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: #fff;
  }
}

.split__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: $hk-apricot;

  &--mira {
    background: $brand-magenta;
  }
}

.split .split__title {
  font-family: $hk-font-heading;
  font-size: 2.6rem;
  font-weight: 900;
  line-height: 1.12;
  color: $hk-linen;
  margin-bottom: 16px;

  &--mira {
    font-family: $font-heading;
    font-weight: 800;
    color: #fff;
  }
}

.split__hl--hk {
  color: $hk-apricot-light;
}

.split__hl--mira {
  background: linear-gradient(135deg, $brand-magenta, $brand-pink);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.split__text {
  font-size: 1rem;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.split__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 28px;
}

.split__chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border-radius: 50px;
  font-size: 0.82rem;
  font-weight: 500;

  &--hk {
    background: rgba(246, 241, 231, 0.08);
    color: rgba(246, 241, 231, 0.9);

    i {
      color: $hk-apricot-light;
    }
  }

  &--mira {
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.88);

    i {
      color: $brand-magenta;
    }
  }
}

.split__btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 30px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all $transition-base;

  i {
    transition: transform $transition-fast;
  }

  &:hover {
    transform: translateY(-2px);

    i {
      transform: translateX(4px);
    }
  }
}

// Vuetify colours every <a>; keep button text on-brand
.v-application a.split__btn--hk {
  background: $hk-apricot;
  color: $hk-forest-deep !important;
  box-shadow: 0 8px 22px rgba(224, 145, 95, 0.35);

  &:hover {
    background: $hk-apricot-light;
  }
}

.v-application a.split__btn--mira {
  background: $brand-gradient;
  color: #fff !important;
  box-shadow: 0 8px 22px rgba(199, 52, 104, 0.35);
}

// ===== Visuals peeking from the bottom edge =====
.split__visual {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 520px;
  height: 300px;
  margin-top: auto;
  padding-top: 40px;
  display: flex;
  justify-content: center;
}

.split__arch {
  position: absolute;
  top: 70px;
  width: 320px;
  height: 400px;
  border-radius: 160px 160px 0 0;
  background: linear-gradient(180deg, rgba(246, 241, 231, 0.12), rgba(246, 241, 231, 0.03));
  border: 1px solid rgba(246, 241, 231, 0.1);
}

.split__phone {
  position: relative;
  transition: transform 0.5s ease;
}

.split__side:hover .split__phone {
  transform: translateY(-14px);
}

.split__plant {
  position: absolute;
  left: 24px;
  bottom: -6px;
  width: 120px;
  z-index: 3;
}

.split__photo {
  position: relative;
  width: 100%;
  height: 340px;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  box-shadow: 0 -10px 50px rgba(0, 0, 0, 0.35);
  transition: transform 0.5s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.split__side:hover .split__photo {
  transform: translateY(-14px);
}

.split__photo-stats {
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-around;
  padding: 12px;
  border-radius: 16px;
  background: rgba(26, 10, 46, 0.85);
  backdrop-filter: blur(10px);

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  strong {
    font-family: $font-heading;
    font-size: 1.3rem;
    font-weight: 800;
    color: #fff;
  }

  span {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.6);
  }
}

// ===== Responsive =====
@media (max-width: 1199px) {
  .split .split__title {
    font-size: 2.2rem;
  }

  .split__plant {
    display: none;
  }
}

@media (max-width: 991px) {
  .split {
    flex-direction: column;
  }

  .split__side {
    padding: 110px 24px 0;
  }

  .split__side--mira {
    padding-top: 64px;
  }
}

@media (max-width: 576px) {
  .split .split__title {
    font-size: 1.9rem;
  }

  .split__visual {
    height: 260px;
  }

  .split__arch {
    width: 280px;
  }
}
</style>
